/**
 * Given a url, this remove duplicate slashes in the url, except for that at the beginning which defines the protocol
 * @param url
 */
export const cleanUrl = (url: string) => url?.replace(/([^:]\/)\/+/g, '$1').replace(/^\/+/, '/');

export const cleanUrlKeepingLeadingDoubleSlash = (url: string) =>
    url?.replace(/([^:]\/)\/+/g, '$1');
